export function useFilterPopoverState() {
  const isOpen = ref(false)

  function toggle() {
    isOpen.value = !isOpen.value
  }

  function hide() {
    isOpen.value = false
  }

  function show() {
    isOpen.value = true
  }

  return {
    isOpen,
    toggle,
    hide,
    show,
  }
}
